








































































































































import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  inject,
  onBeforeMount,
} from '@vue/composition-api'
import CreateUser from './components/user/CreateUser.vue'
import EditUserPermissions from './components/user/EditUserPermissions.vue'
import EditUser from './components/user/EditUser.vue'
import { getUsers, deleteUsers } from '@/shared/api'
import { User } from '@/shared/types'
import { alertSymbol } from '@/shared/state-management/symbols'
import { pagination } from '@/shared/utils'
export default defineComponent({
  name: 'UserOverview',
  components: {
    CreateUser,
    EditUserPermissions,
    EditUser,
  },
  setup(props, { root }) {
    const $alert = inject(alertSymbol) as Function
    const users = ref([])
    const loading = ref(false)
    const editUserPermissionsDialogOpen = ref(false)
    const editUserDialogOpen = ref(false)
    const createUserDialogOpen = ref(false)
    const search = ref('')
    const selectedUsers = ref([])
    const editUser = ref(null)
    const data = reactive({
      headers: [
        {
          text: root.$t('firstname'),
          value: 'firstname',
        },
        {
          text: root.$t('lastname'),
          value: 'lastname',
        },
        {
          text: root.$t('email'),
          value: 'email',
        },
        {
          text: root.$t('users.role'),
          value: 'role',
        },
        {
          text: root.$t('actions'),
          value: 'actions',
        },
      ],
      search: undefined,
    })

    const refreshUsers = async () => {
      loading.value = true
      try {
        const fetchedUsers: Array<User> = (await getUsers()) as Array<User>

        users.value = fetchedUsers.map(
          (user: User): User => ({
            ...user,
          })
        )
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    onBeforeMount(refreshUsers)
    const editItem = (user: User) => {
      editUser.value = user
      editUserDialogOpen.value = true
    }
    const deleteItem = async (user: User) => {
      await $alert({
        type: 'confirm',
        text: root.$t('users.confirmDelete') as string,
      })
      loading.value = true
      try {
        await deleteUsers([user.id])
        $alert({ type: 'success', text: root.$t('users.deletedSuccess') })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
      refreshUsers()
    }

    const deleteSelected = async () => {
      await $alert({
        type: 'confirm',
        text: root.$t('users.confirmDeleteSelected') as string,
      })
      loading.value = true
      try {
        await deleteUsers(selectedUsers.value.map((user) => user.id))
        $alert({ type: 'success', text: root.$t('users.deletedSuccess') })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
      refreshUsers()
    }

    const onUserCreated = () => {
      $alert({ type: 'success', text: root.$t('users.createdSuccess') })
      refreshUsers()
    }

    const onPermissionsEdited = () => {
      refreshUsers()
    }

    const onUserEdited = () => {
      editUserDialogOpen.value = false
      editUser.value = null
      refreshUsers()
    }

    return {
      ...toRefs(data),
      users,
      loading,
      search,
      createUserDialogOpen,
      onUserCreated,
      selectedUsers,
      editItem,
      deleteItem,
      deleteSelected,
      editUserPermissionsDialogOpen,
      onPermissionsEdited,
      editUser,
      editUserDialogOpen,
      onUserEdited,
      pagination,
    }
  },
})
